var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-actions"},[_c('img',{staticClass:"icon",attrs:{"src":require("../../../assets/img-v2/ic_location.png")},on:{"click":_vm.onLocation}})])}
var staticRenderFns = []

export { render, staticRenderFns }